"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyStatusForType = exports.default = exports.PropertyStatusKeys = void 0;
var _values = _interopRequireDefault(require("lodash/values"));
var _listingType = _interopRequireWildcard(require("./listing-type"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PropertyStatusKeys = exports.PropertyStatusKeys = ['FOR_SALE', 'UNDER_OFFER', 'SOLD', 'AVAILABLE_FOR_RENT', 'UNDER_APPLICATION', 'RENTED'];
var PropertyStatusValues = {
  FOR_SALE: {
    name: 'FOR_SALE',
    residentialLabel: 'For Sale',
    commercialLabel: 'For Sale',
    digitalDataKey: 'For Sale',
    urlSlug: 'for-sale',
    listingTypes: [..._listingType.SaleListingTypeKeys, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name]
  },
  UNDER_OFFER: {
    name: 'UNDER_OFFER',
    residentialLabel: 'Under Offer',
    commercialLabel: 'Under Offer',
    digitalDataKey: 'Under Offer',
    urlSlug: 'under-offer',
    listingTypes: [..._listingType.SaleListingTypeKeys, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name]
  },
  SOLD: {
    name: 'SOLD',
    residentialLabel: 'Include sold (last %LISTING_VISIBILITY%)',
    commercialLabel: 'Include sold (last %LISTING_VISIBILITY%)',
    digitalDataKey: 'Sold',
    urlSlug: 'sold',
    listingTypes: [..._listingType.SaleListingTypeKeys, _listingType.default.DEVELOPMENTS_RESIDENTIAL.name]
  },
  AVAILABLE_FOR_RENT: {
    name: 'AVAILABLE_FOR_RENT',
    residentialLabel: 'For Rent',
    commercialLabel: 'For Lease',
    digitalDataKey: 'For Rent',
    urlSlug: 'for-rent',
    listingTypes: _listingType.RentListingTypeKeys
  },
  UNDER_APPLICATION: {
    name: 'UNDER_APPLICATION',
    residentialLabel: 'Under Application',
    commercialLabel: 'Under Application',
    digitalDataKey: 'Under Application',
    urlSlug: 'under-application',
    listingTypes: _listingType.RentListingTypeKeys
  },
  RENTED: {
    name: 'RENTED',
    residentialLabel: 'Rented (last %LISTING_VISIBILITY%)',
    commercialLabel: 'Leased (last %LISTING_VISIBILITY%)',
    digitalDataKey: 'Rented',
    urlSlug: 'rented',
    listingTypes: _listingType.RentListingTypeKeys
  }
};
var PropertyStatus = PropertyStatusValues;
var getPropertyStatusForType = listingType => (0, _values.default)(PropertyStatus).filter(each => each.listingTypes.includes(listingType));
exports.getPropertyStatusForType = getPropertyStatusForType;
var _default = exports.default = PropertyStatus;